import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { AllTickets } from '@core/models/all-tickets.model';

@Injectable()
export class AllTicketsDataService extends DefaultDataService<AllTickets>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('AllTickets', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<AllTickets[]> {
    return this.http.get<ApiResponse>('/event/tickets').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<AllTickets[]>{
    return this.http.get<ApiResponse>(`/event/tickets${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getEvents() {
    return this.http.get<ApiResponse>(`/event`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  exportEvent(params: string) {
    return this.http.get<ApiResponse>(`/event/tickets/export${params}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
